/**
 * Browsing context name for Form Engine Portal tabs opened from Healthcare Portal.
 * `window.open(url, FORM_ENGINE_PORTAL_WINDOW_NAME)` reuses the same tab when it is still open.
 */
export const FORM_ENGINE_PORTAL_WINDOW_NAME = 'hsus-form-engine-portal';
